function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 569px;\n  padding: 32px;\n  margin: 0 auto;\n  text-align: center;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 400px;\n  height: 275px;\n  align-self: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-self: center;\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n\n  .ant-typography {\n    font-size: 12px;\n    margin-top: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: ",
        ";\n  left: 50%;\n  transform: translateX(-50%);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Contact Support."
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Contact Support"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Need help? ",
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
import React from "react";
import { jt, t } from "ttag";
import styled from "styled-components";
import { Button, Typography, Space as AntSpace } from "antd";
import { SUPPORT_EMAIL } from "../../services/support/types";
import AuthLayout from "../Auth/Layout";
var ScopedLayout = styled.div(_templateObject());
var Image = styled.img(_templateObject1());
var Title = styled(Typography.Title)(_templateObject2());
var Text = styled(Typography.Text)(_templateObject3());
var Support = styled.div(_templateObject4());
var CTA = styled.div(_templateObject5(), function(props) {
    return props.scoped ? "absolute" : "relative";
});
var Space = styled(AntSpace)(_templateObject6());
var Layout = function(param) {
    var children = param.children, title = param.title, body = param.body, _param_scoped = param.scoped, scoped = _param_scoped === void 0 ? false : _param_scoped, _param_support = param.support, support = _param_support === void 0 ? false : _param_support, _param_image = param.image, image = _param_image === void 0 ? null : _param_image;
    var contactSupport = /*#__PURE__*/ React.createElement("a", {
        key: "email",
        href: "mailto:".concat(SUPPORT_EMAIL)
    }, t(_templateObject7()));
    if (scoped) {
        return /*#__PURE__*/ React.createElement(ScopedLayout, null, /*#__PURE__*/ React.createElement(Image, {
            src: image,
            alt: ""
        }), /*#__PURE__*/ React.createElement(Title, {
            level: 3
        }, title), /*#__PURE__*/ React.createElement(Text, null, body), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(CTA, {
            scoped: scoped
        }, children, support ? /*#__PURE__*/ React.createElement(Button, {
            type: "default",
            href: "mailto:".concat(SUPPORT_EMAIL)
        }, t(_templateObject8())) : null)));
    }
    return /*#__PURE__*/ React.createElement(AuthLayout, null, /*#__PURE__*/ React.createElement(Space, {
        direction: "vertical",
        size: "middle"
    }, /*#__PURE__*/ React.createElement(Title, {
        level: 4,
        style: {
            textAlign: "center"
        }
    }, title), /*#__PURE__*/ React.createElement(Text, null, body), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(CTA, null, children)), support ? /*#__PURE__*/ React.createElement(Support, null, /*#__PURE__*/ React.createElement(Text, null, jt(_templateObject9(), contactSupport))) : null));
};
export default Layout;
